module.exports = __webpack_public_path__ + "80f14da9074b03bb6ac57074e80ebff4.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/workshop.jpg
 ** module id = 482
 ** module chunks = 0
 **/